const css = require('./export-result.css');
const signals = require('../../../../../signals/account/orders');
const { cut } = require('../../../../../helpers/utils');

const DOWNLOAD_FILE_LINK_SELECTOR = cut(css.downloadFileLink);
const DELETE_DOCUMENT_BUTTON_SELECTOR = cut(css.deleteDocumentButton);
const DOWNLOAD_ALL_BUTTON_SELECTOR = cut(css.downloadAllButton);

class ExportResult {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [DOWNLOAD_FILE_LINK_SELECTOR]: this.downloadFile,
                [DELETE_DOCUMENT_BUTTON_SELECTOR]: this.deleteDocument,
                [DOWNLOAD_ALL_BUTTON_SELECTOR]: this.downloadAll
            }
        };
    }

    downloadFile (e) {
        const fileId = Number(e.target.attributes['cat-id'].value);

        this.$context.signal(signals.downloadFile, { fileId });
    }

    deleteDocument (e) {
        const documentId = e.target.attributes['cat-documentId'].value;

        this.$context.signal(signals.deleteResultDocument, { documentId });
    }

    downloadAll () {
        this.$context.signal(signals.downloadAll);
    }
}

module.exports = {
    constructor: ExportResult
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/export-result/index.js